import ServerRequestUtil from '../utils/ServerRequestUtil';


export default new class {

    async getCoinpaymentsPayInfoData() {
        this.coinpaymentsPayInfoData = await ServerRequestUtil.get('api/app/membership/coinpaymentsPayInfo');
        return Promise.resolve(this.coinpaymentsPayInfoData);
    }
}
